var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShow
    ? _c("div", [
        _c("img", {
          attrs: {
            src: "/static/icon-error.svg",
            alt: "TIVEMOS UM PROBLEMA :("
          }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("TIVEMOS UM PROBLEMA :(")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "error-message" },
          [
            !_vm.customErrorMessage
              ? _c("span", [
                  _vm._v(
                    "Seu pagamento não pode ser processado. Verifique os dados informados(número do cartão, cvv, cpf/cnpj, dentre outros) e tente novamente."
                  )
                ])
              : [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.errorMessageOnPayment.title))
                  ]),
                  _vm._v(" "),
                  _vm.errorMessageOnPayment.subtitle
                    ? _c("span", { staticClass: "subtitle" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.errorMessageOnPayment.subtitle) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessageOnPayment.sugestion
                    ? _c("span", { staticClass: "sugestion" }, [
                        _vm._v(
                          "\n        *" +
                            _vm._s(_vm.errorMessageOnPayment.sugestion) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ]
          ],
          2
        ),
        _vm._v(" "),
        !_vm.shouldBlockPayment
          ? _c(
              "button",
              {
                staticClass: "btn bg-pink",
                on: { click: _vm.returnToPayment }
              },
              [_vm._v("\n    Voltar para tentar novamente\n  ")]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-141342d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-141342d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/Components/Error.vue
// module id = null
// module chunks = 